/*
Author  : Born Group.
main jQuery widget of Fpmini
*/

define('Born_PerformanceFixes/js/product_page',[
    'jquery',
    'jquery/ui',
    'mage/translate',
    'Born_WeltPixelGtm/js/born_gtm',
    'mage/gallery/gallery',
    'owl_carousel',
    'slick',
    'fancybox'
], function ($, ui, _responsive, born_gtm, gallery) {
    'use strict';

    $.widget('planetsports.initProductPage', {

        _create: function () {
            this.initProductPage();
        },

        initProductPage: function () {

            if ($('body.catalog-product-view').length) {

                var checkInterval = setInterval(function () {
                    var loaderContainer = $('.swatch-attribute');

                    //Return if loader still load
                    if (loaderContainer.length == 0) {
                        return;
                    }

                    //Remove loader and clear update interval if content loaded
                    if (loaderContainer.length > 0) {
                        clearInterval(checkInterval);

                        /*fixed gallery image load issue, after selecting size*/
                        $('body').on('change', '.swatch-select.size', function () {
                            if ($('.swatch-attribute.color .swatch-option.selected').length > 0) {
                                $('.swatch-option.selected').trigger('click');
                            }
                        });

                        /*on page load select size if only single size available on PDP*/
                        var swatchSizeLength = $('select.size option').length;
                        if(swatchSizeLength == 2){
                            $('select.size option').eq(1).attr("selected","selected");
                            $('select.size option').eq(1).trigger('change');
                        }
                        var chartTitle = $.mage.__('Size Chart');
                        var swatchErrorTitle = $.mage.__('Choose Your Size');
                        var size_guide_info = '';
                        if ($('[data-size-guide="size_guide_info"]').length) {
                            size_guide_info = $.mage.__($('[data-size-guide="size_guide_info"]').text());
                        }

                        if ($(window).width() > 768) {
                            if(document.getElementById("sizechart-id") != null){
                               $('.swatch-attribute[class*=size] .swatch-attribute-label').before('<div class="swatch-error-notice">' + swatchErrorTitle + '</div>' + '<span class="size-guide-info">' + size_guide_info + '</span><a href="#" class="open-chart">' + chartTitle + '</a>');
                            }
                        } else {
                            if(document.getElementById("sizechart-id") != null){
                               $('.swatch-attribute[class*=size] .swatch-attribute-label').append('<div class="swatch-error-notice">' + swatchErrorTitle + '</div>');
                               $('.swatch-attribute[class*=size]').before('<span class="size-guide-info">' + size_guide_info + '</span><a href="#" class="open-chart">' + chartTitle + '</a>');
                            }
                        }

                        $('.swatch-error-notice').hide();


                        $('.product-options-wrapper .open-chart').click(function (e) {
                            $.fancybox.open('#sizechart-id');
                        });
                        born_gtm.triggerChartTrack();
                        $('.swatch-attribute-label').parent().addClass('expanded');
                        $('.swatch-attribute-label').click(function () {
                            $(this).parent().toggleClass('expanded');
                        });

                        $('.swatch-option.text').click(function () {
                            $('.swatch-option.text').removeClass('error');
                            $('.swatch-error-notice').hide();
                        });

                        /* on page load disable add to cart button*/
                        $('.product-addtocart-button-cls').attr('disabled', true);

                    }
                }, 100);

                /* START- Fix- if no any swatch attributes only size dropdown*/
                var checkIsSizeDropdownLoadedInterval = setInterval(function () {
                    var isSizeDropdownOnPDP = $('.super-attribute-select.size');
                    if (isSizeDropdownOnPDP.length == 0) {
                        return;
                    }
                    if (isSizeDropdownOnPDP.length > 0) {
                        clearInterval(checkIsSizeDropdownLoadedInterval);
                        var chartTitle = $.mage.__('Size Chart');
                        var swatchErrorTitle = $.mage.__('Choose Your Size');
                        var size_guide_info = '';
                        if ($('[data-size-guide="size_guide_info"]').length) {
                            size_guide_info = $.mage.__($('[data-size-guide="size_guide_info"]').text());
                        }

                        if ($(window).width() > 768) {
                            if(document.getElementById("sizechart-id") != null){
                                $('.super-attribute-select.size').parent().parent().find('label').before('<div class="swatch-error-notice">' + swatchErrorTitle + '</div>' + '<span class="size-guide-info">' + size_guide_info + '</span><a href="#" class="open-chart">' + chartTitle + '</a>');
                            }
                        } else {
                            if(document.getElementById("sizechart-id") != null){
                                $('.super-attribute-select.size').parent().parent().find('label').append('<div class="swatch-error-notice">' + swatchErrorTitle + '</div>');
                                $('.super-attribute-select.size').parent().parent().find('label').before('<span class="size-guide-info">' + size_guide_info + '</span><a href="#" class="open-chart">' + chartTitle + '</a>');
                            }
                        }
                        $('.swatch-error-notice').hide();
                        $('.product-options-wrapper .open-chart').click(function (e) {
                            $.fancybox.open('#sizechart-id');
                        });
                        born_gtm.triggerChartTrack();

                        /* on page load disable add to cart button*/
                        $('.product-addtocart-button-cls').attr('disabled', true);
                    }
                }, 100);
                /* END- Fix- if no any swatch attributes only size dropdown*/

                $('.desc-wrap h1').click(function () {
                    $(this).parent().toggleClass('expanded');
                });
                $('.product-info-similar h2').click(function () {
                    $(this).parent().toggleClass('expanded');
                });
                var discPrice = $('.product-info-main > .discount-pdp');
                $('.product-info-main .old-price.sly-old-price').append(discPrice);
                if ($(window).width() <= 767) {
                    var wishlist = $('.product-info-main .product-addto-links').clone();
                    $('.product.info.detailed').after(wishlist);

                    $('.product.data.items .data.item.title').click(function () {
                        $(this).toggleClass('expanded');
                    });

                    var checkIntervalPhoto = setInterval(function () {
                        if ($('.fotorama__nav.fotorama__nav--thumbs').length) {
                            $('.fotorama__stage').height($('.fotorama__stage').width());
                            clearInterval(checkIntervalPhoto);
                        }
                    }, 1000);
                }
                var boxqty = $('.box-tocart .field.qty').clone();
                $('.product.attribute.sku').before(boxqty);

                var windowWidthPdp = $(window).width();
                $('#buy-now').click(function () {

                    if ($('.swatch-attribute').length) {
                        var attrId = $('.swatch-attribute').attr('attribute-id');
                        var checkInterval = setInterval(function () {
                            if ($('.super-attribute-select').hasClass('mage-error')) {
                                $(".swatch-option.text").addClass('error');
                                $('.super-attribute-select.mage-error + div').hide();
                                $('.swatch-error-notice').show();
                            } else {
                                $(".swatch-option.text").removeClass('error');
                                $('.swatch-error-notice').hide();
                            }
                            clearInterval(checkInterval);
                        }, 500);
                    }
                });

                $('.product-addtocart-button-cls').click(function () {

                    if ($('.swatch-attribute').length) {
                        var attrId = $('.swatch-attribute').attr('attribute-id');
                        var checkInterval = setInterval(function () {
                            if ($('.super-attribute-select').hasClass('mage-error')) {
                                $(".swatch-option.text").addClass('error');
                                $('.super-attribute-select.mage-error + div').hide();
                                $('.swatch-error-notice').show();
                            } else {
                                $(".swatch-option.text").removeClass('error');
                                $('.swatch-error-notice').hide();
                            }
                            clearInterval(checkInterval);
                        }, 500);
                    }
                });

                $(document).on('mouseover', '.fotorama__nav__frame', function () {
                    return false; //to stop mouse over functionality for gallery thumb
                });

                /* show social share icon on mouse over on PDP page*/
                $('[data-action="social-sharing"]').mouseenter(function () {
                    $('[data-action="social-media-icons"]').removeClass('hidden');
                    $(this).addClass('hidden');
                    setTimeout(function () {
                        $('.social-icons').each(function () {
                            $(this).attr('onClick', $(this).data('click'));

                        });
                    }, 500);
                });
                $('[data-action="social-media-icons"]').mouseleave(function () {
                    $(this).addClass('hidden');
                    $('[data-action="social-sharing"]').removeClass('hidden');
                });

                /* after option selected enable add to cart button */
                $('body').on('click', '.swatch-option', function () {
                    if ($('.swatch-option.selected').length > 0 && $('select.swatch-select').children("option:selected").val() > 0) {
                        $('.product-addtocart-button-cls').removeAttr('disabled');
                        if ($('.price-range-container').length > 0) {
                            $('.price-wrapper-container, .price-range-container').removeClass('no-display');
                            $('.price-range-container').addClass('no-display');
                        }
                    } else {
                        $('.product-addtocart-button-cls').attr('disabled', true);
                        if ($('.price-range-container').length > 0) {
                            $('.price-wrapper-container, .price-range-container').removeClass('no-display');
                            $('.price-wrapper-container').addClass('no-display');
                        }
                    }
                });
                $('body').on('change', '.swatch-select', function () {
                    if ($('.swatch-option.selected').length > 0 && $(this).val() > 0) {
                        $('.product-addtocart-button-cls').removeAttr('disabled');
                        if ($('.price-range-container').length > 0) {
                            $('.price-wrapper-container, .price-range-container').removeClass('no-display');
                            $('.price-range-container').addClass('no-display');
                        }
                    } else {
                        $('.product-addtocart-button-cls').attr('disabled', true);
                        if ($('.price-range-container').length > 0) {
                            $('.price-wrapper-container, .price-range-container').removeClass('no-display');
                            $('.price-wrapper-container').addClass('no-display');
                        }
                    }
                });

                $('body').on('change', '.super-attribute-select', function () {
                    if ($(this).val() > 0) {
                        $('.product-addtocart-button-cls').removeAttr('disabled');
                        if ($('.price-range-container').length > 0) {
                            $('.price-wrapper-container, .price-range-container').removeClass('no-display');
                            $('.price-range-container').addClass('no-display');
                        }
                    } else {
                        $('.product-addtocart-button-cls').attr('disabled', true);
                        if ($('.price-range-container').length > 0) {
                            $('.price-wrapper-container, .price-range-container').removeClass('no-display');
                            $('.price-wrapper-container').addClass('no-display');
                        }
                    }
                });

                $('body').on('change', '.super-attribute-select', function () {
                    if ($(this).val() > 0) {
                        $('.product-addtocart-button-cls').removeAttr('disabled');
                        if ($('.price-range-container').length > 0) {
                            $('.price-wrapper-container, .price-range-container').removeClass('no-display');
                            $('.price-range-container').addClass('no-display');
                        }
                    } else {
                        $('.product-addtocart-button-cls').attr('disabled', true);
                        if ($('.price-range-container').length > 0) {
                            $('.price-wrapper-container, .price-range-container').removeClass('no-display');
                            $('.price-wrapper-container').addClass('no-display');
                        }
                    }
                });
            }
            if ($(window).width() < 769) {
                if ($('body').hasClass('.catalog-product-view')) {
                    $(".header-top").css('display', 'none');
                }
            }
            $(document).ready(function () {
                if($(window).width() < 769){
                    $('[data-gallery-role=gallery-placeholder]').on('gallery:loaded', function () {
                        $(this).on('fotorama:ready', function(){
                            if ($('.amlabel-position-wrapper').length) {
                                $(".amlabel-position-wrapper").appendTo(".gallery-placeholder .fotorama__stage");
                                $('.amlabel-position-wrapper').addClass('amlabel-loaded');
                            }
                        });
                });
                }

                //Sticky Add to cart_
                if ($(window).width() < 769) {
                    $('.catalog-product-view .box-tocart').addClass('pdpsticky');
                }

                //sticky description
                if ($(window).width() < 767) {
                    $('.product.media').css('min-height', 'auto');
                    $(".product-info-main").insertBefore(".product.media");
                }
                $(".more_button").click(function () {
                    $('html,body').animate({
                            scrollTop: $(".pdp-description-section").offset().top
                        },
                        'slow');
                });

                if ($(window).width() > 767) {
                    $('.product-info-main').wrap('<div class="new-parent"></div>');
                    $('.product-info-main').addClass("desc_start");
                    var infoWidth=  $('.product-info-main.desc_start').width();
                    // $(".new-parent").appendTo(".columns");
                    $.fn.is_on_screen = function () {
                        var win = $(window);
                        var viewport = {
                            top: win.scrollTop(),
                            left: win.scrollLeft()
                        };
                        viewport.right = viewport.left + win.width();
                        viewport.bottom = viewport.top + win.height();

                        var bounds = this.offset();
                        bounds.right = bounds.left + this.outerWidth();
                        bounds.bottom = bounds.top + this.outerHeight();

                        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
                    };

                    $(window).scroll(function () {
                        if ($('.page-bottom').length > 0) {
                            if ($('.page-bottom').is_on_screen()) {
                                $('.product-info-main').addClass('scroll-off');
                                $('.product-info-main').removeClass('fixed');
                            } else {
                                $('.product-info-main').removeClass('scroll-off');
                                $('.product-info-main').addClass('fixed');
                                $('.product-info-main').css('width',infoWidth);
                            }
                        }
                    });
                    $(window).scroll(function () {
                        if ($(this).scrollTop() > 100) {
                            $('.product-info-main').addClass("desc_start");
                        } else {
                            $('.product-info-main').removeClass("fixed");
                        }
                    });
                }
            });
        },

    });

    return $.planetsports.initProductPage;

});

